<div>
  <div class="m-t-15 m-b-5">
    <span>{{ question.name }}</span>
  </div>
</div>
<form [formGroup]="textQuestionForm">
  <div class="m-b-10">
    <input *ngIf="getIsNumberForm()" formControlName="customValue" class="form-control question-number-body" type="number" (focusout)="saveAnswer()" />
    <textarea *ngIf="!getIsNumberForm()" 
    formControlName="customValue" class="form-control question-text-body" (focusout)="saveAnswer()">
    </textarea>
  </div>
</form>